import Action from '../../classes/Action';
import {ActionDescription, ActionParameters}   from '../../classes/api/APIDecorators';
import AssetsManager from "../../classes/AssetsManager";
import Scenario from "../../classes/scenarioElements/Scenario";
import ScenarioHealthUtils from "../../classes/utilities/ScenarioHealthUtils";
import store, { StoreActions } from '../../state/store';
import {RegisterActionWithAPI} from "../../classes/api/Decorators";

export interface SlideTemplate {
	slide: string;
	synced: boolean;
	[key: string]: any;
}
export default class SetSlideAction extends Action
{
	constructor(stepIDs: string[], slide: string)
	{
		const previousSlides: SlideTemplate[] = [];
		if (stepIDs && stepIDs.length > 0)
		{
			for (let i = 0; i < stepIDs.length; i++)
			{
				previousSlides.push({ ...store.getState().uiModule.ui[stepIDs[i]] });
			}
		}

		super(
			[stepIDs, slide],
			[stepIDs, previousSlides],
			`Set Step Slide`,
			[stepIDs, slide]
		);
	}

	do(steps: string[], slide: string)
	{
		let slideTemplate: SlideTemplate;
		if (!slide)
		{
			slideTemplate = { slide: "", synced: false };
		}
		else
		{
			slideTemplate = { ...store.getState().uiModule.slideMaster[slide], slide: slide, synced: true };
		}
		delete slideTemplate.name;
		delete slideTemplate.type;

		const ui = store.getState().uiModule.ui;

		for (let i = 0; i < steps.length; i++)
		{
			// remove old used slide
			if (ui[steps[i]])
			{
				const oldSlide = ui[steps[i]]?.slide;
				oldSlide && AssetsManager.removeUsedAsset(oldSlide);
			}

			// Don't reset a slide if it's already set, it will just reset the data
			if ( ui[steps[i]]?.slide != slide )
			{
				store.dispatch(StoreActions.ui.setFromCopy({ stepId: steps[i], content: { ...slideTemplate } }));
			}

			// set new used slide
			AssetsManager.addUsedAsset(slide);
		}
		
		ScenarioHealthUtils.CheckForQuizResults();
		steps.forEach(stepId => ScenarioHealthUtils.CheckUISystemUsageForStep(Scenario.getStep(stepId)));
	}

	undo(steps: string[], previousSlides: SlideTemplate[])
	{
		for (let i = 0; i < steps.length; i++)
		{
			// remove old used slide
			AssetsManager.removeUsedAsset(store.getState().uiModule.ui[steps[i]].slide);

			store.dispatch(StoreActions.ui.setFromCopy({ stepId: steps[i], content: { ...previousSlides[i] } }));

			// add new used slide
			AssetsManager.addUsedAsset(store.getState().uiModule.ui[steps[i]].slide);
		}

		ScenarioHealthUtils.CheckForQuizResults();
		steps.forEach(stepId => ScenarioHealthUtils.CheckUISystemUsageForStep(Scenario.getStep(stepId)));
	}

	verify(steps: string[], slide: string): boolean
	{
		if (!steps || steps.length === 0) return false;
		const slideMaster = store.getState().uiModule.slideMaster;
		const slideMasterElement = slideMaster[slide];
		if (!slideMasterElement && slide !== "") return false;
		return true;
	}
}
